import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-becario',
  templateUrl: './content-becario.component.html',
  styleUrls: ['./content-becario.component.css']
})
export class ContentBecarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
